import { Navigate } from "react-router-dom";
import { getCookie, isMobileView } from "./Utility";
export const AuthPrivateRoute = ({ children }) => {
  const userlog =
    getCookie("userlog") !== "" ? JSON.parse(getCookie("userlog")) : null;

  if (userlog) {
    return <Navigate to="/" />;
  }

  return children;
};

export const StorePrivateRoute = ({ children }) => {
  const userlog =
    getCookie("userlog") !== "" ? JSON.parse(getCookie("userlog")) : null;
  if (!userlog) {
    return <Navigate to="/auth" />;
  }

  return children;
};

export const CustomerPrivateRoute = ({ children }) => {
  let customerlog = sessionStorage.getItem("customerlog");

  if (!customerlog) {
    const localCustomer =
      localStorage.getItem("customerlog") || getCookie("customerlog");
    if (localCustomer) {
      try {
        const parsed =
          typeof localCustomer === "string"
            ? JSON.parse(localCustomer)
            : localCustomer;
        const serialized = JSON.stringify(parsed);
        sessionStorage.setItem("customerlog", serialized);
        if (parsed.id) {
          sessionStorage.setItem("id", parsed.id);
        }
        const franchiseMobile = localStorage.getItem("franchise_mobile");
        if (franchiseMobile) {
          sessionStorage.setItem("franchise_mobile", franchiseMobile);
        }
        const customerId = localStorage.getItem("customer_id");
        if (customerId) {
          sessionStorage.setItem("customer_id", customerId);
        }
        const iddetails = localStorage.getItem("iddetails");
        if (iddetails) {
          sessionStorage.setItem("iddetails", iddetails);
        }
        customerlog = serialized;
      } catch (e) {
        console.error("Failed to restore customer session", e);
      }
    }
  }

  const id = getCookie("franchiseid");

  // An active customer session takes precedence over a stale shop redirect.
  if (customerlog) {
    return children;
  }

  // Franchise shop redirect
  if (id && id.trim() !== "") {
    console.log("isStartUrl0");
    return <Navigate to={`/kansas_product/shop/${id}`} replace />;
  }

  // 🔥 Allow PWA to load restore page on first open
  if (isMobileView) {
    console.log("isStartUrl1");
    return children;
  }

  // Normal auth in browser
  console.log("isStartUrl2");
  return <Navigate to="/" />;
};

export const VerifyPrivateRoute = ({ children }) => {
  const verifyStatus = sessionStorage.getItem("otpStatus");
  if (verifyStatus !== null) {
    return <Navigate to="/store" />;
  }
  return children;
};
